import React, { useContext } from 'react';
import { Route, Switch, Redirect } from 'react-router';

import { Layout } from './components/Layout';
import { ReportViewer } from './components/ReportViewer';
import { TenantEditor } from './components/TenantEditor';
import { ReportEditor } from './components/ReportEditor';
import { AuvikDeviceReport } from './components/AuvikDeviceReport';
import './custom.css'
import { AuthContext } from './AuthContext';

export const App = () => {
    const authContext = useContext(AuthContext)
    var defaultPath = "/noAccess";
    if (authContext.isReportReader || AuthContext.isAdministrator){
        defaultPath = "/reports";
    }
    else if (authContext.isNocProf){
        defaultPath= "/auvikDeviceReport"
    }
    
    return (
        <div>
            {authContext.isAuthenticated == true &&
                <Layout>
                    <Switch>
                        <Route exact path='/' >
                            <Redirect to={defaultPath} />
                        </Route>
                        <Route path='/noAccess'>
                            <div>
                                You do not have permission to access the application.  If you believe you should have access, please notify your contact at Networking Technologies.
                            </div>
                        </Route>
                        {authContext.isAdministrator &&
                            <Route path="/reports/manage" component={ReportEditor} />
                        }
                        {authContext.isReportReader &&
                            <Route path="/reports" component={ReportViewer} />
                        }
                        {authContext.isReportReader &&
                            <Route path="/tenants" component={TenantEditor} />
                        }
                        {
                            authContext.isNocProf &&
                            <Route path="/auvikDeviceReport" component={AuvikDeviceReport} />
                        }
                    </Switch>

                </Layout>
            }
            {authContext.isAuthenticated == false &&
                <div>Preparing your access to the system.</div>
            }
        </div>
    )
}

